import React, { useEffect } from "react";
import { create } from "zustand";
import DataListStore from "../../store/DataListStore";
import ListViewV2 from "../App/DataListV2";
import { Button, Space } from "antd";
import { ProCard } from "@ant-design/pro-components";
import { GetStatusPesananSummary } from "services/datalist/datalist-api";

const defaultDataStore = create(DataListStore);

const DashboardPesanan = () => {
  const [summary, setSummary] = React.useState([]);
  const [filters, setfilters] = React.useState({ filters: [] });
  const [activeStatus, setActiveStatus] = React.useState(null);

  useEffect(() => {
    GetStatusPesananSummary().then((res) => {
      setSummary(res);
    });
  }, []);

  return (
    <ListViewV2
      hideFilter={true}
      filters={filters}
      defaultSize="small"
      store={defaultDataStore}
      viewId={"dashboardpesanan"}
      addExtraRender={() => {
        return (
          <ProCard bordered boxShadow>
            <Space wrap>
              {summary.map((item) => (
                <Button
                  key={item.Status}
                  type={item.Status === activeStatus ? "primary" : "default"}
                  onClick={() => {
                    if (item.Status === activeStatus) {
                      setActiveStatus(null);
                      setfilters({ filters: [] });
                      return;
                    }
                    setActiveStatus(item.Status);
                    setfilters({
                      filters: [
                        {
                          filterField: "Status",
                          filterOperator: "EQUALS",
                          filterValue: item.Status,
                        },
                      ],
                    });
                  }}
                >
                  {item.Status} ( {item.Total} )
                </Button>
              ))}
            </Space>
          </ProCard>
        );
      }}
    />
  );
};

export default DashboardPesanan;
